import React from 'react'
import IncidentPerAttribute from './IncidentPerAttribute'


const MonitorsIncidentsPerUser = () => {

    const monitorReport = true;

    return (
        <>
            <IncidentPerAttribute monitorReport={monitorReport} attributeType ="user_id" disaggregation = "validity" />
        </>
    
  )
}

export default MonitorsIncidentsPerUser